import navbar from '../../../playturbo/src/lang/en/navbar'
import ptCommon from '../../../playturbo/src/lang/en/common'
import versionlist from '../../../playturbo/src/lang/en/versionList'
import websocket from '../../../playturbo/src/lang/en/websocket'
import uploader from '../../../warehouse/src/lang/en/uploader'
import cropperDialog from '../../../warehouse/src/lang/en/cropperDialog'
import common from '../../../warehouse/src/lang/en/common.js'
import custom from '../../../playturbo/src/lang/en/custom'
import commonTemplate from '../../../playturbo/src/lang/en/commonTemplate'
import animation from './en/animation'
import audioCutter from './en/audioCutter'
import audio from './en/audio'
import board from './en/board'
import image from './en/image'
import psNavbar from './en/navbar'
import layerManager from './en/layerManager'
import layoutEditor from './en/layoutEditor'
import leftPane from './en/leftPane'
import globalSetting from './en/globalSetting'
import animationSetting from './en/animationSetting'
import designSetting from './en/designSetting'
import eventSetting from './en/event-setting/index'
import sceneSetting from './en/sceneSetting'
import sceneManager from './en/sceneManager'
import sequenceFrame from './en/sequenceFrame'
import text from './en/text'
import utils from './en/utils'
import video from './en/video'
import particle from './en/particle'
import particleParent from './en/particleParent'
import resourceManagers from './en/resourceManager'
import preView from './en/preview'
import iconText from './en/icon'
import mixin from './en/mixin'
import commonNavbar from '@/lang/en/downloadBasic'
import basic from '@com/lang/en/basic'
import track from '@com/lang/en/track'
import creative from '@pt/lang/en/creative'
import gamePlay from '@pt/lang/en/gamePlay'
import exportHistory from '@pt/lang/en/exportHistory'
import leftMenu from '@pt/lang/en/leftMenu'
import recordProject from '@pt/lang/en/recordProject'
import videoProject from '@pt/lang/en/videoProject'
import playableProject from '@pt/lang/en/playableProject'
import promoteManagement from '@pt/lang/en/promoteManagement'
import assetLibrary from '@pt/lang/en/assetLibrary'
import playableAds from '@pt/lang/en/playableAds'
import whole from '@pt/lang/en/whole'
import ps from './en/ps'
import taskCenter from '@pt/lang/en/taskCenter'
import pushDialog from '@pt/lang/en/pushDialog'
import authAccount from '@pt/lang/en/authAccount'

// import workbenchs from '@com/lang/zh/workbench'
import resourceManager from '@com/lang/en/resourceManager'
import drawLine from './en/drawLine'
import box2d from './en/box2d'
import billing from '@pt/lang/en/billing'
import profile from '@pt/lang/en/profile'
import dashboard from '@pt/lang/en/dashboard'
import playComponent from './en/playComponent'
import erase from './en/erase'
import carousel from './en/carousel'
import park from './en/park'
import mask from './en/mask'
import puzzle from './en/puzzle'
import shelves from './en/shelves'
import iv from './en/interactive-video'

export default {
  basic,
  track,
  ps,
  // workbenchs,
  resourceManager,

  commonNavbar,
  common,
  uploader,
  cropperDialog,
  playTurbo: {
    navbar,
    common: ptCommon,
    custom,
    versionlist,
    commonTemplate,
    pushDialog,
    authAccount,
    websocket,
    creative,
    gamePlay,
    exportHistory,
    recordProject,
    videoProject,
    playableProject,
    promoteManagement,
    assetLibrary,
    leftMenu,
    whole,
    playableAds,
    taskCenter,
    billing,
    profile,
    dashboard,
  },
  icon: {
    iconText,
  },
  preview: {
    preView,
  },
  workbench: {
    animation,
    audio,
    audioCutter,
    board,
    image,
    psNavbar,
    layerManager,
    leftPane,
    globalSetting,
    animationSetting,
    designSetting,
    eventSetting,
    sceneSetting,
    sceneManager,
    layoutEditor,
    sequenceFrame,
    text,
    utils,
    video,
    particle,
    particleParent,
    resourceManagers,
    mixin,
    drawLine,
    box2d,
    playComponent,
    erase,
    carousel,
    park,
    mask,
    puzzle,
    shelves,
  },
  interactiveVideo: {
    iv,
  },
}
